module.exports = __webpack_public_path__ + "c1134431c4f07bf29a76058097690d58.svg";